let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4kV2M")).then(() => parcelRequire('azjDO'));